// src/features/packaging/corrugated/questions/ManufacturingCountrySelect.jsx
import React from "react";
import { Box } from "@mui/material";
import PerlChip from "../../../../shared/components/PerlChip";
import PerlLabelMedium from "../../../../shared/components/PerlLabelMedium";
import PerlTextField from "../../../../shared/components/PerlTextField";
import PerlAutocomplete from "../../../../shared/components/PerlAutocomplete";

// Countries to show as chips
const CHIP_COUNTRIES = ["China", "India", "USA", "Japan"];

// All country options
const ALL_COUNTRIES = [
  "Albania",
  "Argentina",
  "Australia",
  "Austria",
  "Belgium",
  "Bosnia",
  "Brazil",
  "Bulgaria",
  "Canada",
  "China",
  "Czech Republic",
  "Denmark",
  "Egypt",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hong Kong",
  "Hungary",
  "India",
  "Indonesia",
  "Ireland",
  "Italy",
  "Japan",
  "Luxembourg",
  "Malaysia",
  "Mauritius",
  "Mexico",
  "Morocco",
  "Netherlands",
  "New Zealand",
  "Philiphines",
  "Philippines",
  "Poland",
  "Portugal",
  "Romania",
  "Russia",
  "Saudi Arabia",
  "Serbia",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Thailand",
  "Tunisia",
  "Turkey",
  "UAE",
  "United Kingdom",
  "USA",
  "Vietnam",
];

// Countries for dropdown (all countries except chip countries)
const DROPDOWN_COUNTRIES = ALL_COUNTRIES.filter((country) => !CHIP_COUNTRIES.includes(country));

export default function ManufacturingCountrySelect({ value, onChange }) {
  const selectedCountry = value || "";

  const handleCountrySelect = (country) => {
    // Toggle selection: if already selected, deselect; otherwise select
    const newValue = selectedCountry === country ? "" : country;
    onChange?.(newValue);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
      {/* <PerlLabelMedium sx={{ mb: 2, display: "block" }}>Manufacturing Country:</PerlLabelMedium> */}
      
      <PerlTextField
        label="Selected Manufacturing Country"
        placeholder="Select a country from below or enter custom country"
        value={selectedCountry}
        onChange={(e) => onChange?.(e.target.value)}
        fullWidth
      />
      
      {/* Chip countries */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          mb: 2,
        }}
      >
        {CHIP_COUNTRIES.map((country) => (
          <Box key={country} sx={{ width: "auto", flexShrink: 0 }}>
            <PerlChip
              label={country}
              onClick={() => handleCountrySelect(country)}
              selected={selectedCountry === country}
            />
          </Box>
        ))}
      </Box>

      {/* Dropdown for other countries */}
      <PerlAutocomplete
        label="Other Countries"
        value={CHIP_COUNTRIES.includes(selectedCountry) ? "" : selectedCountry}
        onChange={(_, newValue) => {
          if (newValue) {
            onChange?.(newValue);
          } else {
            onChange?.("");
          }
        }}
        options={DROPDOWN_COUNTRIES}
        placeholder="Select from other countries"
      />
    </Box>
  );
}

